import * as angular from 'angular';
import { HttpService } from '../../../../../app.common/modules/api/http.service';
import { RetailerService } from '../../../api/retailer.service';
import { IPagingResult } from '../../../model/IPagingResult.model';
import { IVendor } from './models/IVendor';
import { IVendorSearchFilter } from './models/IVendorSearchFilter';

export class VendorsService {

    public static $inject = ['http', 'retailerService'];

    constructor(
        private http: HttpService,
        private retailerService: RetailerService) { }

    public getVendors(filter: IVendorSearchFilter) {
        return this.http.get<IPagingResult<IVendor>>(this.retailerService.getVendors(), { params: filter });
    }

    public getVendor(vendorID: number) {
        return this.http.get<IVendor>(this.retailerService.getVendor(vendorID));
    }

    public createOrUpdateVendor(vendor: IVendor, vendorID?: number) {
        if (vendorID == null) {
            return this.http.post<number>(this.retailerService.getVendors(), vendor);
        } else {
            return this.http.put(this.retailerService.getVendor(vendorID), vendor);
        }
    }

    public archiveVendor(vendorID: number) {
        return this.http.put(this.retailerService.archiveVendor(vendorID), null);
    }

    public restoreVendor(vendorID: number) {
        return this.http.put(this.retailerService.restoreVendors(vendorID), null);
    }

    public saveVendorImageUrl() {
        return this.retailerService.createVendorImage();
    }

    public getVendorImageUrl(imageID: number) {
        return;
        // return this.retailerService.getExtraImage(imageID);
    }

}

angular
    .module('naut')
    .service('vendorsService', VendorsService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/jispPay/components/vendors/vendors.service.ts